"use client";

import { ContentfulImage } from "@components/ContentfulImage";
import Link from "@components/Link";
import type { BaseArticleFragment, Maybe } from "@server/gql/graphql";

import { cn } from "@/lib/utils";

import { formatIsoDate } from "@/utils/formatDate";
import { Heading, Paragraph } from "../ui";

export default function ArticleCard({
  data,
  slug,
  locale,
}: {
  data: Maybe<BaseArticleFragment> | null;
  slug?: Maybe<string>;
  locale: string;
}) {
  if (!data || !slug) return null;

  return (
    <div
      className={cn("group/article flex h-auto flex-col first:col-span-full")}
    >
      <Link locale={locale} href={slug} className="flex h-full flex-col">
        <div className={cn("relative group-first/article:h-full")}>
          <ContentfulImage
            className={cn(
              "aspect-portrait h-full w-full object-cover group-first/article:aspect-[12/5]",
            )}
            desktopImage={
              // @todo Do not use any
              (data?.desktopHeroImage as any) ?? undefined
            }
            mobileImage={
              // @todo Do not use any
              (data?.mobileHeroImage as any) ?? undefined
            }
          />
        </div>

        <div className="mt-4">
          <Paragraph className="uppercase">
            {formatIsoDate(data.publishingDate, locale)}
          </Paragraph>
          <Heading as="h3" className="truncate text-lg lg:text-[20px]">
            {data.title}
          </Heading>
        </div>
      </Link>
    </div>
  );
}
